/* eslint-disable @nx/enforce-module-boundaries */
import { Divider, HStack, Heading, Link, Stack, Text } from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { MyProfileContext } from '../context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const MyProfileDegreeConnections = forwardRef(
  ({ active, ...props }, ref) => {
    const { myConnections, refetchMyConnections } =
      useContext(MyProfileContext);
    useEffect(() => {
      refetchMyConnections?.();
    }, []);
    const { t } = useTranslator();
    // eslint-disable-next-line no-unsafe-optional-chaining
    const [first, second, third] = myConnections?.map?.(
      (c) => c?.length ?? '0'
    );

    return (
      <>
        <Stack spacing={0}>
          <Stack
            p={2}
            bg={active === 'first' ? 'brandGray.500' : ''}
            _hover={{ bg: 'brandGray.500' }}
            as={Link}
            href={'/profile/network/my-circle'}
          >
            <HStack>
              <Heading size="sm" fontWeight="bold" color="brandPrimary.500">
                {first ?? 0}
              </Heading>
              <Heading size="sm">{t('publicProfile.firstDegree') || "1st degree"}</Heading>
            </HStack>
            <Text size="xs">
              {t('publicProfile.mutualNetworksPeopleOn') || "Mutual Networks. People on"} Jhone Doe {t('publicProfile.firstDegreeConnectionDetail') || "1st Degree connection that you are directly connected to because of your professional relationships, or you’ve accepted their handshake."}
            </Text>
          </Stack>
          <Divider />
          <Stack
            p={2}
            bg={active === 'second' ? 'brandGray.500' : ''}
            _hover={{ bg: 'brandGray.500' }}
            as={Link}
            href={'/profile/network/my-circle/second'}
          >
            <HStack>
              <Heading size="sm" fontWeight="bold" color="brandPrimary.500">
                {second ?? 0}
              </Heading>
              <Heading size="sm">{t('publicProfile.secondDegree') || "2nd degree"}</Heading>
            </HStack>
            <Text size="xs">
              {t('publicProfile.peopleConnectedFirstDegree') || "People who are connected to your 1st-degree connections. You can send them a handshake request to move them to a 1st connection."}
            </Text>
          </Stack>
          <Divider />
          <Stack
            p={2}
            bg={active === 'third' ? 'brandGray.500' : ''}
            _hover={{ bg: 'brandGray.500' }}
            as={Link}
            href={'/profile/network/my-circle/third'}
          >
            <HStack>
              <Heading size="sm" fontWeight="bold" color="brandPrimary.500">
                {third ?? 0}
              </Heading>
              <Heading size="sm">{t('publicProfile.thirdDegree') || "3rd degree"}</Heading>
            </HStack>
            <Text size="xs">
              {t('publicProfile.peopleConnectedSecondDegree') || "People who are connected to your 2nd-degree connections. You can send them a handshake request to move them to a 1st connection."}
            </Text>
          </Stack>
        </Stack>
      </>
    );
  }
);
